import ReactDOM from "react-dom/client";
import { Route, Routes, Navigate, BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import STORE, { persistor } from "./redux";

import App from "./components/App";
import PatientList from "./components/PatientList";
import PatientDetail from "./components/PatientDetail";
import OktaLogin from "./components/Login/OktaLogin";
import FhirSearch from "./components/FhirSearch";
import Patients from "./components/ViewData/Patients";
import ReadmissionsDashboard from "./components/ReadmissionDashboard";
import OktaPasswordHelp from "./components/Login/OktaPasswordHelp";
import ClaimReview from "./components/ClaimReview";
import Dashboard from "./components/Dashboard";
import UserManagement from "./components/UserManagement";
import ClosedLoop from "./components/ClosedLoop";
import TrafficCop from "./components/TrafficCop";
import ClaimTracker from "./components/ClaimTracker";
import PatientView from "./components/PatientView";
import { initAccessTokenBridge } from "./lib/authToken";
import MirthAuditLog from "./components/MirthAuditLog";
import LeadsSummary from "./components/LeadsSummary";
import LeadsMemberDetail from "./components/LeadsSummary/MemberDetail";
import MembersSummary from "./components/MembersSummary";
import MembersMemberDetail from "./components/MembersSummary/MemberDetail";
import PreScreening from "./components/PreScreening";
import ToastContainer from "./components/ToastContainer/ToastContainer";
import QuickSightReports from "./components/QuickSightReports";
import { AuthRootLayout } from "./auth/AuthRootLayout";
import { LoginCallback } from "./auth/LoginCallback";
import { RequireAuth } from "./auth/RequireAuth";
import { RequireTabAccess } from "./auth/RequireTabAccess";
import PostLoginRedirect from "./auth/PostLoginRedirect";
import { LogoutPage } from "./auth/LogoutPage";
import MortalityAlerts from "./components/MortalityAlert/MortalityAlert";

// Preserve old bookmarked links from the previous HashRouter setup.
// BrowserRouter ignores everything after "#", so convert "#/path?query" to
// the equivalent pathname before React Router reads the current location.
if (window.location.hash.startsWith("#/")) {
  window.history.replaceState(
    window.history.state,
    "",
    window.location.hash.slice(1)
  );
}

initAccessTokenBridge();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={STORE}>
    <PersistGate loading={null} persistor={persistor}>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route element={<AuthRootLayout />}>
            <Route path="/login" element={<OktaLogin />} />
            <Route path="/login/callback" element={<LoginCallback />} />
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="/forget-password" element={<OktaPasswordHelp />} />
            <Route path="/patient/mrn/:mrn" element={<PatientView />} />
            <Route path="/" element={<PostLoginRedirect />} />

            <Route element={<RequireAuth />}>
              <Route element={<RequireTabAccess />}>
                <Route element={<App settings={{}} dispatch={() => {}} />}>
                  <Route path="/fhir-search" element={<FhirSearch />} />
                  <Route path="/view" element={<Patients />} />
                  <Route path="/claim-tracker" element={<ClaimTracker />} />
                  <Route path="/claim-review" element={<ClaimReview />} />
                  <Route path="/closed-loop" element={<ClosedLoop />} />
                  <Route path="/leads-summary" element={<LeadsSummary />} />
                  <Route
                    path="/leads-summary/member/:memberId"
                    element={<LeadsMemberDetail />}
                  />
                  <Route path="/members-summary" element={<MembersSummary />} />
                  <Route
                    path="/members-summary/member/:memberId"
                    element={<MembersMemberDetail />}
                  />
                  <Route path="/traffic-cop" element={<TrafficCop />} />
                  <Route path="/patient-list" element={<PatientList />} />
                  <Route path="/patient/:index" element={<PatientDetail />} />
                  <Route
                    path="/readmission-dashboard"
                    element={<ReadmissionsDashboard />}
                  />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/user-management" element={<UserManagement />} />
                  <Route path="/mirth-audit-log" element={<MirthAuditLog />} />
                  <Route path="/pre-screening" element={<PreScreening />} />
                  <Route path="/quicksight-reports" element={<QuickSightReports />} />
		  <Route path="/mortality-alert" element={<MortalityAlerts />} />
                </Route>
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
